import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Header from '../../Header/Header';
import App from '../../Licencia/flags/flags';

function Pantalla3Lic() {

    const [blContinue, setBlContinue] = useState(false);
    const [showHeader, setShowHeader] = useState(false);
    const [valueSelectNat, setValueSelectNat] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        setBlContinue(true);
    });

    const onValueSelectNat = (newSelect) => {
        setValueSelectNat(newSelect);
    }

    const onContinue = async () => {
        navigate("/AppIncodeLicencia", {
            state: {
                rutaContinue: "/PantallaBase8Lic",
                typeCredential: "lic"
            }
        });
    }

    return (
        <>

            {!showHeader ? (
                <>
                    <Header imgBack={true} rutaBack='/PantallaBase2Lic' title='Licencia de Conducir' />
                </>
            ) : (
                <></>
            )}

            <div className='containerInfo_P2'>
                <div className='containerIdent_P2'>
                    <p className='txtNat_P3'>Nacionalidad</p>

                    <App />

                    {!blContinue ? (
                        <>
                            <hr className='line' />
                            <button className='btnVer_P3' >
                                <span className='txtVer_P3'>Continuar</span>
                            </button>
                            <br />
                        </>
                    ) : (
                        <>
                            <hr className='line' />
                            <button className='button_P2' onClick={onContinue}>
                                <span className='txtButton_P2'>Continuar</span>
                            </button>
                            <br />
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

export default Pantalla3Lic
